/* eslint-disable */
/* tslint:disable */

export enum MoveType {
  Position = 'position',
  CenterOn = 'centerOn',
  Direction = 'direction',
}

export type GetPTZPositionCameraId = string;

export type MovePTZParams = {
  cameraId: string;
  movementData: ApiPtzMove;
};

export type PtzZoomStatus = ApiPtzPosition & {
  cameraId: string;
};

/**
 * The ptz coordinates of the camera in a space defined as pan:(-1,1), tilt:(-1,1), zoom:(0,1).
 */
export interface ApiPtzPosition {
  /**
   * Pan coordinate given as value between -1(max left) and 1(max right).
   * @format double
   * @min -1
   * @max 1
   */
  x?: number;

  /**
   * Tilt coordinate given as value between -1(max down) and 1(max up).
   * @format double
   * @min -1
   * @max 1
   */
  y?: number;

  /**
   * Zoom coordinate given as value between 0(fully zoomed out) and 1(fully zoomed in).
   * @format double
   * @min 0
   * @max 1
   */
  z?: number;
}

/**
 * Moves the camera to a ptz coordinate in a space defined as pan:(-1,1), tilt:(-1,1), zoom:(0,1). This move is normally used for moving to presets. It is not only possible to give the full x,y,z coordinates here, you can also either give only x,y or give only z.
 */
export type ApiPtzPositionMove = ApiPtzPosition;

export type ApiPtzMove = (ApiPtzCenterOnMove | ApiPtzDirectionMove | ApiPtzPositionMove) & { moveType: MoveType };

/**
 * Move the center of the camera to the indicated(clicked) point within the shown image. The point is encoded as the relative x and y based on the width and height of the shown image on a scale from 0 to 1, where the (0,0) coordinate is top left and (1,1) is bottom right.
 */
export interface ApiPtzCenterOnMove {
  /**
   * relative x coordinate.
   * @format double
   * @min 0
   * @max 1
   */
  relativeX: number;

  /**
   * relative y coordinate.
   * @format double
   * @min 0
   * @max 1
   */
  relativeY: number;
}

/**
 * Move the camera in the given direction.
 */
export interface ApiPtzDirectionMove {
  /** The direction to move in. */
  direction: ('up' | 'down' | 'left' | 'right' | 'in' | 'out')[];

  /** How much we will move, if no stepSize is given then `medium` stepsize is taken. */
  stepSize?: 'small' | 'medium' | 'large';
}
